import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Asymmetric from "@/app/page";
import "@/app/globals.css";
import "@/app/minimal-design.css";
import "@/app/approved-design.css";
import "@/app/decision-engine.css";
import AuthGate from "./auth-gate";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthGate>
      <Asymmetric />
    </AuthGate>
  </StrictMode>,
);
